module.exports = __webpack_public_path__ + "static/media/Feature1_svg.a8cd0d90.svg";